export default {
  list: [
    {
      displayName: 'Afghanistan',
      value: 'AF',
    },
    {
      displayName: 'Åland Islands',
      value: 'AX',
    },
    {
      displayName: 'Albania',
      value: 'AL',
    },
    {
      displayName: 'Algeria',
      value: 'DZ',
    },
    {
      displayName: 'American Samoa',
      value: 'AS',
    },
    {
      displayName: 'Andorra',
      value: 'AD',
    },
    {
      displayName: 'Angola',
      value: 'AO',
    },
    {
      displayName: 'Anguilla',
      value: 'AI',
    },
    {
      displayName: 'Antarctica',
      value: 'AQ',
    },
    {
      displayName: 'Antigua and Barbuda',
      value: 'AG',
    },
    {
      displayName: 'Argentina',
      value: 'AR',
    },
    {
      displayName: 'Armenia',
      value: 'AM',
    },
    {
      displayName: 'Aruba',
      value: 'AW',
    },
    {
      displayName: 'Australia',
      value: 'AU',
    },
    {
      displayName: 'Austria',
      value: 'AT',
    },
    {
      displayName: 'Azerbaijan',
      value: 'AZ',
    },
    {
      displayName: 'Bahamas',
      value: 'BS',
    },
    {
      displayName: 'Bahrain',
      value: 'BH',
    },
    {
      displayName: 'Bangladesh',
      value: 'BD',
    },
    {
      displayName: 'Barbados',
      value: 'BB',
    },
    {
      displayName: 'Belarus',
      value: 'BY',
    },
    {
      displayName: 'Belgium',
      value: 'BE',
    },
    {
      displayName: 'Belize',
      value: 'BZ',
    },
    {
      displayName: 'Benin',
      value: 'BJ',
    },
    {
      displayName: 'Bermuda',
      value: 'BM',
    },
    {
      displayName: 'Bhutan',
      value: 'BT',
    },
    {
      displayName: 'Bolivia (Plurinational State of)',
      value: 'BO',
    },
    {
      displayName: 'Bonaire, Sint Eustatius and Saba',
      value: 'BQ',
    },
    {
      displayName: 'Bosnia and Herzegovina',
      value: 'BA',
    },
    {
      displayName: 'Botswana',
      value: 'BW',
    },
    {
      displayName: 'Bouvet Island',
      value: 'BV',
    },
    {
      displayName: 'Brazil',
      value: 'BR',
    },
    {
      displayName: 'British Indian Ocean Territory',
      value: 'IO',
    },
    {
      displayName: 'Brunei Darussalam',
      value: 'BN',
    },
    {
      displayName: 'Bulgaria',
      value: 'BG',
    },
    {
      displayName: 'Burkina Faso',
      value: 'BF',
    },
    {
      displayName: 'Burundi',
      value: 'BI',
    },
    {
      displayName: 'Cabo Verde',
      value: 'CV',
    },
    {
      displayName: 'Cambodia',
      value: 'KH',
    },
    {
      displayName: 'Cameroon',
      value: 'CM',
    },
    {
      displayName: 'Canada',
      value: 'CA',
    },
    {
      displayName: 'Cayman Islands',
      value: 'KY',
    },
    {
      displayName: 'Central African Republic',
      value: 'CF',
    },
    {
      displayName: 'Chad',
      value: 'TD',
    },
    {
      displayName: 'Chile',
      value: 'CL',
    },
    {
      displayName: 'China',
      value: 'CN',
    },
    {
      displayName: 'Christmas Island',
      value: 'CX',
    },
    {
      displayName: 'Cocos (Keeling) Islands',
      value: 'CC',
    },
    {
      displayName: 'Colombia',
      value: 'CO',
    },
    {
      displayName: 'Comoros',
      value: 'KM',
    },
    {
      displayName: 'Congo',
      value: 'CG',
    },
    {
      displayName: 'Congo, Democratic Republic of the',
      value: 'CD',
    },
    {
      displayName: 'Cook Islands',
      value: 'CK',
    },
    {
      displayName: 'Costa Rica',
      value: 'CR',
    },
    {
      displayName: "Côte d'Ivoire",
      value: 'CI',
    },
    {
      displayName: 'Croatia',
      value: 'HR',
    },
    {
      displayName: 'Cuba',
      value: 'CU',
    },
    {
      displayName: 'Curaçao',
      value: 'CW',
    },
    {
      displayName: 'Cyprus',
      value: 'CY',
    },
    {
      displayName: 'Czechia',
      value: 'CZ',
    },
    {
      displayName: 'Denmark',
      value: 'DK',
    },
    {
      displayName: 'Djibouti',
      value: 'DJ',
    },
    {
      displayName: 'Dominica',
      value: 'DM',
    },
    {
      displayName: 'Dominican Republic',
      value: 'DO',
    },
    {
      displayName: 'Ecuador',
      value: 'EC',
    },
    {
      displayName: 'Egypt',
      value: 'EG',
    },
    {
      displayName: 'El Salvador',
      value: 'SV',
    },
    {
      displayName: 'Equatorial Guinea',
      value: 'GQ',
    },
    {
      displayName: 'Eritrea',
      value: 'ER',
    },
    {
      displayName: 'Estonia',
      value: 'EE',
    },
    {
      displayName: 'Eswatini',
      value: 'SZ',
    },
    {
      displayName: 'Ethiopia',
      value: 'ET',
    },
    {
      displayName: 'Falkland Islands (Malvinas)',
      value: 'FK',
    },
    {
      displayName: 'Faroe Islands',
      value: 'FO',
    },
    {
      displayName: 'Fiji',
      value: 'FJ',
    },
    {
      displayName: 'Finland',
      value: 'FI',
    },
    {
      displayName: 'France',
      value: 'FR',
    },
    {
      displayName: 'French Guiana',
      value: 'GF',
    },
    {
      displayName: 'French Polynesia',
      value: 'PF',
    },
    {
      displayName: 'French Southern Territories',
      value: 'TF',
    },
    {
      displayName: 'Gabon',
      value: 'GA',
    },
    {
      displayName: 'Gambia',
      value: 'GM',
    },
    {
      displayName: 'Georgia',
      value: 'GE',
    },
    {
      displayName: 'Germany',
      value: 'DE',
    },
    {
      displayName: 'Ghana',
      value: 'GH',
    },
    {
      displayName: 'Gibraltar',
      value: 'GI',
    },
    {
      displayName: 'Greece',
      value: 'GR',
    },
    {
      displayName: 'Greenland',
      value: 'GL',
    },
    {
      displayName: 'Grenada',
      value: 'GD',
    },
    {
      displayName: 'Guadeloupe',
      value: 'GP',
    },
    {
      displayName: 'Guam',
      value: 'GU',
    },
    {
      displayName: 'Guatemala',
      value: 'GT',
    },
    {
      displayName: 'Guernsey',
      value: 'GG',
    },
    {
      displayName: 'Guinea',
      value: 'GN',
    },
    {
      displayName: 'Guinea-Bissau',
      value: 'GW',
    },
    {
      displayName: 'Guyana',
      value: 'GY',
    },
    {
      displayName: 'Haiti',
      value: 'HT',
    },
    {
      displayName: 'Heard Island and McDonald Islands',
      value: 'HM',
    },
    {
      displayName: 'Holy See',
      value: 'VA',
    },
    {
      displayName: 'Honduras',
      value: 'HN',
    },
    {
      displayName: 'Hong Kong',
      value: 'HK',
    },
    {
      displayName: 'Hungary',
      value: 'HU',
    },
    {
      displayName: 'Iceland',
      value: 'IS',
    },
    {
      displayName: 'India',
      value: 'IN',
    },
    {
      displayName: 'Indonesia',
      value: 'ID',
    },
    {
      displayName: 'Iran (Islamic Republic of)',
      value: 'IR',
    },
    {
      displayName: 'Iraq',
      value: 'IQ',
    },
    {
      displayName: 'Ireland',
      value: 'IE',
    },
    {
      displayName: 'Isle of Man',
      value: 'IM',
    },
    {
      displayName: 'Israel',
      value: 'IL',
    },
    {
      displayName: 'Italy',
      value: 'IT',
    },
    {
      displayName: 'Jamaica',
      value: 'JM',
    },
    {
      displayName: 'Japan',
      value: 'JP',
    },
    {
      displayName: 'Jersey',
      value: 'JE',
    },
    {
      displayName: 'Jordan',
      value: 'JO',
    },
    {
      displayName: 'Kazakhstan',
      value: 'KZ',
    },
    {
      displayName: 'Kenya',
      value: 'KE',
    },
    {
      displayName: 'Kiribati',
      value: 'KI',
    },
    {
      displayName: "Korea (Democratic People's Republic of)",
      value: 'KP',
    },
    {
      displayName: 'Korea, Republic of',
      value: 'KR',
    },
    {
      displayName: 'Kuwait',
      value: 'KW',
    },
    {
      displayName: 'Kyrgyzstan',
      value: 'KG',
    },
    {
      displayName: "Lao People's Democratic Republic",
      value: 'LA',
    },
    {
      displayName: 'Latvia',
      value: 'LV',
    },
    {
      displayName: 'Lebanon',
      value: 'LB',
    },
    {
      displayName: 'Lesotho',
      value: 'LS',
    },
    {
      displayName: 'Liberia',
      value: 'LR',
    },
    {
      displayName: 'Libya',
      value: 'LY',
    },
    {
      displayName: 'Liechtenstein',
      value: 'LI',
    },
    {
      displayName: 'Lithuania',
      value: 'LT',
    },
    {
      displayName: 'Luxembourg',
      value: 'LU',
    },
    {
      displayName: 'Macao',
      value: 'MO',
    },
    {
      displayName: 'Madagascar',
      value: 'MG',
    },
    {
      displayName: 'Malawi',
      value: 'MW',
    },
    {
      displayName: 'Malaysia',
      value: 'MY',
    },
    {
      displayName: 'Maldives',
      value: 'MV',
    },
    {
      displayName: 'Mali',
      value: 'ML',
    },
    {
      displayName: 'Malta',
      value: 'MT',
    },
    {
      displayName: 'Marshall Islands',
      value: 'MH',
    },
    {
      displayName: 'Martinique',
      value: 'MQ',
    },
    {
      displayName: 'Mauritania',
      value: 'MR',
    },
    {
      displayName: 'Mauritius',
      value: 'MU',
    },
    {
      displayName: 'Mayotte',
      value: 'YT',
    },
    {
      displayName: 'Mexico',
      value: 'MX',
    },
    {
      displayName: 'Micronesia (Federated States of)',
      value: 'FM',
    },
    {
      displayName: 'Moldova, Republic of',
      value: 'MD',
    },
    {
      displayName: 'Monaco',
      value: 'MC',
    },
    {
      displayName: 'Mongolia',
      value: 'MN',
    },
    {
      displayName: 'Montenegro',
      value: 'ME',
    },
    {
      displayName: 'Montserrat',
      value: 'MS',
    },
    {
      displayName: 'Morocco',
      value: 'MA',
    },
    {
      displayName: 'Mozambique',
      value: 'MZ',
    },
    {
      displayName: 'Myanmar',
      value: 'MM',
    },
    {
      displayName: 'Namibia',
      value: 'NA',
    },
    {
      displayName: 'Nauru',
      value: 'NR',
    },
    {
      displayName: 'Nepal',
      value: 'NP',
    },
    {
      displayName: 'Netherlands',
      value: 'NL',
    },
    {
      displayName: 'New Caledonia',
      value: 'NC',
    },
    {
      displayName: 'New Zealand',
      value: 'NZ',
    },
    {
      displayName: 'Nicaragua',
      value: 'NI',
    },
    {
      displayName: 'Niger',
      value: 'NE',
    },
    {
      displayName: 'Nigeria',
      value: 'NG',
    },
    {
      displayName: 'Niue',
      value: 'NU',
    },
    {
      displayName: 'Norfolk Island',
      value: 'NF',
    },
    {
      displayName: 'North Macedonia',
      value: 'MK',
    },
    {
      displayName: 'Northern Mariana Islands',
      value: 'MP',
    },
    {
      displayName: 'Norway',
      value: 'NO',
    },
    {
      displayName: 'Oman',
      value: 'OM',
    },
    {
      displayName: 'Pakistan',
      value: 'PK',
    },
    {
      displayName: 'Palau',
      value: 'PW',
    },
    {
      displayName: 'Palestine, State of',
      value: 'PS',
    },
    {
      displayName: 'Panama',
      value: 'PA',
    },
    {
      displayName: 'Papua New Guinea',
      value: 'PG',
    },
    {
      displayName: 'Paraguay',
      value: 'PY',
    },
    {
      displayName: 'Peru',
      value: 'PE',
    },
    {
      displayName: 'Philippines',
      value: 'PH',
    },
    {
      displayName: 'Pitcairn',
      value: 'PN',
    },
    {
      displayName: 'Poland',
      value: 'PL',
    },
    {
      displayName: 'Portugal',
      value: 'PT',
    },
    {
      displayName: 'Puerto Rico',
      value: 'PR',
    },
    {
      displayName: 'Qatar',
      value: 'QA',
    },
    {
      displayName: 'Réunion',
      value: 'RE',
    },
    {
      displayName: 'Romania',
      value: 'RO',
    },
    {
      displayName: 'Russian Federation',
      value: 'RU',
    },
    {
      displayName: 'Rwanda',
      value: 'RW',
    },
    {
      displayName: 'Saint Barthélemy',
      value: 'BL',
    },
    {
      displayName: 'Saint Helena, Ascension and Tristan da Cunha',
      value: 'SH',
    },
    {
      displayName: 'Saint Kitts and Nevis',
      value: 'KN',
    },
    {
      displayName: 'Saint Lucia',
      value: 'LC',
    },
    {
      displayName: 'Saint Martin (French part)',
      value: 'MF',
    },
    {
      displayName: 'Saint Pierre and Miquelon',
      value: 'PM',
    },
    {
      displayName: 'Saint Vincent and the Grenadines',
      value: 'VC',
    },
    {
      displayName: 'Samoa',
      value: 'WS',
    },
    {
      displayName: 'San Marino',
      value: 'SM',
    },
    {
      displayName: 'Sao Tome and Principe',
      value: 'ST',
    },
    {
      displayName: 'Saudi Arabia',
      value: 'SA',
    },
    {
      displayName: 'Senegal',
      value: 'SN',
    },
    {
      displayName: 'Serbia',
      value: 'RS',
    },
    {
      displayName: 'Seychelles',
      value: 'SC',
    },
    {
      displayName: 'Sierra Leone',
      value: 'SL',
    },
    {
      displayName: 'Singapore',
      value: 'SG',
    },
    {
      displayName: 'Sint Maarten (Dutch part)',
      value: 'SX',
    },
    {
      displayName: 'Slovakia',
      value: 'SK',
    },
    {
      displayName: 'Slovenia',
      value: 'SI',
    },
    {
      displayName: 'Solomon Islands',
      value: 'SB',
    },
    {
      displayName: 'Somalia',
      value: 'SO',
    },
    {
      displayName: 'South Africa',
      value: 'ZA',
    },
    {
      displayName: 'South Georgia and the South Sandwich Islands',
      value: 'GS',
    },
    {
      displayName: 'South Sudan',
      value: 'SS',
    },
    {
      displayName: 'Spain',
      value: 'ES',
    },
    {
      displayName: 'Sri Lanka',
      value: 'LK',
    },
    {
      displayName: 'Sudan',
      value: 'SD',
    },
    {
      displayName: 'Suriname',
      value: 'SR',
    },
    {
      displayName: 'Svalbard and Jan Mayen',
      value: 'SJ',
    },
    {
      displayName: 'Sweden',
      value: 'SE',
    },
    {
      displayName: 'Switzerland',
      value: 'CH',
    },
    {
      displayName: 'Syrian Arab Republic',
      value: 'SY',
    },
    {
      displayName: 'Taiwan, Province of China',
      value: 'TW',
    },
    {
      displayName: 'Tajikistan',
      value: 'TJ',
    },
    {
      displayName: 'Tanzania, United Republic of',
      value: 'TZ',
    },
    {
      displayName: 'Thailand',
      value: 'TH',
    },
    {
      displayName: 'Timor-Leste',
      value: 'TL',
    },
    {
      displayName: 'Togo',
      value: 'TG',
    },
    {
      displayName: 'Tokelau',
      value: 'TK',
    },
    {
      displayName: 'Tonga',
      value: 'TO',
    },
    {
      displayName: 'Trinidad and Tobago',
      value: 'TT',
    },
    {
      displayName: 'Tunisia',
      value: 'TN',
    },
    {
      displayName: 'Turkey',
      value: 'TR',
    },
    {
      displayName: 'Turkmenistan',
      value: 'TM',
    },
    {
      displayName: 'Turks and Caicos Islands',
      value: 'TC',
    },
    {
      displayName: 'Tuvalu',
      value: 'TV',
    },
    {
      displayName: 'Uganda',
      value: 'UG',
    },
    {
      displayName: 'Ukraine',
      value: 'UA',
    },
    {
      displayName: 'United Arab Emirates',
      value: 'AE',
    },
    {
      displayName: 'United Kingdom of Great Britain and Northern Ireland',
      value: 'GB',
    },
    {
      displayName: 'United States of America',
      value: 'US',
    },
    {
      displayName: 'United States Minor Outlying Islands',
      value: 'UM',
    },
    {
      displayName: 'Uruguay',
      value: 'UY',
    },
    {
      displayName: 'Uzbekistan',
      value: 'UZ',
    },
    {
      displayName: 'Vanuatu',
      value: 'VU',
    },
    {
      displayName: 'Venezuela (Bolivarian Republic of)',
      value: 'VE',
    },
    {
      displayName: 'Viet Nam',
      value: 'VN',
    },
    {
      displayName: 'Virgin Islands (British)',
      value: 'VG',
    },
    {
      displayName: 'Virgin Islands (U.S.)',
      value: 'VI',
    },
    {
      displayName: 'Wallis and Futuna',
      value: 'WF',
    },
    {
      displayName: 'Western Sahara',
      value: 'EH',
    },
    {
      displayName: 'Yemen',
      value: 'YE',
    },
    {
      displayName: 'Zambia',
      value: 'ZM',
    },
    {
      displayName: 'Zimbabwe',
      value: 'ZW',
    },
  ],
};
